export const useCodeAndNameRequired = ({ codeNameAndUniqueness }) =>
  codeNameAndUniqueness === 'NAMEANDCODEUNIQUE'
    ? { isCodeRequired: true, isNameRequired: true }
    : codeNameAndUniqueness === 'CODEUNIQUENAMENOTUNIQUE'
    ? { isCodeRequired: true, isNameRequired: false }
    : { isCodeRequired: false, isNameRequired: true };
